import React from "react";

import { createClassNameString } from "../../../component-library";

import "./styles.scss";

const Hr = ({ className }) => {
  return <hr className={createClassNameString(["Hr m-0", className])} />;
};

export default Hr;
